import { Progress } from "antd";
import React from "react";
import { getVitalColorCode } from "@src/helpers/constants";

interface CustomProgressBarProps {
  record: any;
}

const CustomProgressBar: React.FC<CustomProgressBarProps> = ({ record }) => {
  return (
    <div className="custom-progress-bar">
      <span>{record?.value}</span>
      {record?.color && (
        <Progress
          percent={100}
          showInfo={false}
          // Map the semantic colour ("green"/"orange"/"red"/"yellow"/"dark_red")
          // to a valid hex. Passing the raw value let invalid CSS names like
          // "dark_red" fall back to the theme primary, making critical readings
          // look normal.
          strokeColor={getVitalColorCode(record?.color)}
          className="custom-progress"
        />
      )}
    </div>
  );
};

export default CustomProgressBar;
